export default {
  "title": "XzjJm",
  "image": "lM7GU",
  "webview": "FP2cL"
};